import { useState } from "react";

import { Alert } from "react-bootstrap";
import { UserNotificationInfo } from "common-util-experience-client";
import { createUserNotificationsApi } from "../api-helpers/CommonUtilsApiHelper";
import { LoadingHelper } from "../components/loader/LoadingHelper";
import Notification from "./Notification";
import TaskNotification from "./TaskNotification";

const userNotificationsApi = createUserNotificationsApi();

interface Props {
  notifications: UserNotificationInfo[];
  onUpdate: (notifications: UserNotificationInfo[]) => void;
  onCloseModalTrigger: () => void
}

const NotificationsList = (props: Props) => {
  const [notifications, setNotifications] = useState<UserNotificationInfo[]>(props.notifications);

  const loadNotifications = async () => {
    LoadingHelper.showLoader(".notifications-list");
    try {
      const { data } = await userNotificationsApi.userNotificationsControllerGetUserNotifications();
      setNotifications(data);
    } finally {
      LoadingHelper.hideLoader(".notifications-list");
    }
  }

  const markNotificationAsViewed = async (id: string) => {
    LoadingHelper.showLoader(".notifications-list");
    try {
      await userNotificationsApi.userNotificationsControllerMarkViewed(id);

      const updatedNotifications = notifications?.filter(notification => notification.id != id);
      setNotifications(updatedNotifications);
      props.onUpdate(updatedNotifications);
    } finally {
      LoadingHelper.hideLoader(".notifications-list");
    }
  }

  const markAllNotificationsAsViewed = async () => {
    LoadingHelper.showLoader(".notifications-list");
    try {
      await userNotificationsApi.userNotificationsControllerMarkAllViewed();
      setNotifications([]);
      props.onUpdate([]);
    } finally {
      LoadingHelper.hideLoader(".notifications-list");
    }
  }

  return (
    <div className="notifications-list d-flex flex-column gap-1">
      {(notifications?.length ?? 0) > 0 && (
        <div className="w-full d-flex justify-content-end">
          <span
            className=" text-primary fw-bold underline text-decoration-underline clear-all-btn"
            onClick={markAllNotificationsAsViewed}
          >
            Clear All
          </span>
        </div>
      )}

      {notifications?.map((notification) =>
        notification.refType.toLowerCase() === "task" ? (
          <TaskNotification
            key={notification.id}
            notification={notification}
            onDeleteClicked={() => markNotificationAsViewed(notification.id)}
            onCloseModalTrigger={props.onCloseModalTrigger}
          />
        ) : (
          <Notification
            key={notification.id}
            notification={notification}
            onDeleteClicked={() => markNotificationAsViewed(notification.id)}
            onCloseModalTrigger={props.onCloseModalTrigger}
          />
        )
      )}

      {notifications?.length == 0 && (
        <Alert className="d-flex mb-4" key={"danger"} variant={"danger"}>
          <div className="me-2">
            <span className="material-symbols-outlined fs-20 align-top">
              warning
            </span>
          </div>
          <div className="flex-fill">You don't have any new notifications.</div>
        </Alert>
      )}
    </div>
  );
}

export default NotificationsList;
